import SkillBoxGroup from "./SkillBoxGroup";

export default SkillBoxGroup;
